import { format } from "date-fns";
import api from "./api";


export const dashboardCount = async () => {

  const response = await api.get(`/api/personal-info/counts`);
  return response.data;
}


export const userLoginDashboard = async (employeeUniqueId, startDate) => {
  const response = await api.get(`/api/attendance/summary?employeeUniqueId=${employeeUniqueId}&date=${format(startDate, 'yyyy-MM-dd')}`);
  return response.data;
}




export const getPresentEmployees = async (districtId, date) => {
  const formatted = format(date, 'yyyy-MM-dd');   // backend expects ISO format

  const response = await api.get(`api/attendance/present-employees-by-district?districtId=${districtId}&date=${formatted}`)
  return response.data;

};


export const getAbsentEmployees = async (districtId, today) => {
  const formatted = format(today, 'yyyy-MM-dd');
  const res = await api.get(`api/attendance/absent-employees-by-district?districtId=${districtId}&date=${formatted}`);
  return res.data;
};




export const getNotintheLocationEmployees = async (districtId, date) => {
  const formatted = format(date, 'yyyy-MM-dd');
  const res = await api.get(`api/attendance/employees-with-remarks?districtId=${districtId}&date=${formatted}`);
  return res.data;
};
// ITM

export const sameDatesAttendanceForItm = async (itmDistrictId, today) => {
  const response = await api.get(`/api/attendance/report-by-district?districtId=${itmDistrictId}&fromDate=${format(today, 'yyyy-MM-dd')}&toDate=${format(today, 'yyyy-MM-dd')}`)
  return response.data;
}

export const sameDatesAttendanceForItmReport = async (itmDistrictId, fromDate, toDate) => {
  const response = await api.get(`/api/attendance/report-by-district?districtId=${itmDistrictId}&fromDate=${format(fromDate, 'yyyy-MM-dd')}&toDate=${format(toDate, 'yyyy-MM-dd')}`)
  return response.data;
}

export const differentDatesAttendanceForItm = async (itmDistrictId, fromDate, toDate) => {
  const response = await api.get(`/api/attendance/district-summary-by-itm?districtId=${itmDistrictId}&fromDate=${format(fromDate, 'yyyy-MM-dd')}&toDate=${format(toDate, 'yyyy-MM-dd')}`)
  return response.data;
}

// ZONE APM   


export const zoneAttendaceWithoutDistrict = async (zoneId, today) => {
  const response = await api.get(`/api/attendance/zone-attendance-summary?zoneId=${zoneId}&date=${format(today, 'yyyy-MM-dd')}`)
  return response.data;
}

export const zoneAttendaceWithDistrict = async (district, today) => {
  const response = await api.get(`/api/attendance/report-by-district?districtId=${district}&fromDate=${format(today, 'yyyy-MM-dd')}&toDate=${format(today, 'yyyy-MM-dd')}`)
  return response.data;
}

export const getPresentEmployeesZone = async (zoneId, today, districtId) => {
 
  const formatted = format(today, "yyyy-MM-dd");
  let url = `api/attendance/zone-present-report?zoneId=${zoneId}&fromDate=${formatted}&toDate=${formatted}`;
  if (districtId) {
    url += `&districtId=${districtId}`;
  }

  const response = await api.get(url);
  return response.data;

};

export const getAbsentEmployeesZone = async (zoneId, today, districtId) => {
  const formatted = format(today, 'yyyy-MM-dd');
  let url = `api/attendance/zone-absent-leave-report?zoneId=${zoneId}&fromDate=${formatted}&toDate=${formatted}`;
  if (districtId) {
    url += `&districtId=${districtId}`;
  }
  // const res = await api.get(`api/attendance/zone-absent-leave-report?zoneId=${ZoneId}&fromDate=${formatted}&toDate=${formatted}`);
  const response = await api.get(url);
  return response.data;
};


export const getNotInLocationEmployeesZone = async (zoneId, today, districtId) => {
  const formatted = format(today, 'yyyy-MM-dd');
  let url = `/api/attendance/zone-not-in-location-report?zoneId=${zoneId}&fromDate=${formatted}&toDate=${formatted}`;
  if (districtId) {
    url += `&districtId=${districtId}`;
  }
  const response = await api.get(url);
  return response.data;
};

export const getAllEmployeesZone = async (zoneId, today, districtId) => {
  const formatted = format(today, 'yyyy-MM-dd');
  let url = `/api/attendance/zone-all-employees-report?zoneId=${zoneId}&date=${formatted}`;
  if (districtId) {
    url += `&districtId=${districtId}`;
  }
  const response = await api.get(url);
  return response.data;
};

//http://localhost:8080/api/attendance/zone-all-employees-report?zoneId=2&date=2025-11-14
//PM Dashboard


export const attendaceWithoutStatePM = async (stateId, today) => {
  const response = await api.get(`/api/attendance/state-attendance-summary?stateId=${stateId}&date=${format(today, 'yyyy-MM-dd')}`)
  return response.data;
}





export const getPresentEmployeesStatePM = async (stateId, today, districtId) => {
  const formatted = format(today, "yyyy-MM-dd");

  let url = `api/attendance/state-present-report?stateId=${stateId}&fromDate=${formatted}&toDate=${formatted}`;

  // ADD district param only if available
  if (districtId) {
    url += `&districtId=${districtId}`;
  }

  const response = await api.get(url);
  return response.data;
};



export const getAbsentEmployeesStatePM = async (stateId, today, districtId) => {
  const formatted = format(today, 'yyyy-MM-dd');
  let url = `/api/attendance/state-absent-report?stateId=${stateId}&fromDate=${formatted}&toDate=${formatted}`;
  if (districtId) {
    url += `&districtId=${districtId}`;
  }

  const response = await api.get(url);
  return response.data;
};

export const getNotInLocationEmployeesStatePM = async (stateId, today, districtId) => {
  const formatted = format(today, 'yyyy-MM-dd');
  let url = `/api/attendance/state-not-in-location-report?stateId=${stateId}&fromDate=${formatted}&toDate=${formatted}`;
  if (districtId) {
    url += `&districtId=${districtId}`;
  }

  const response = await api.get(url);
  return response.data;
};


export const getAllEmployeesStatePM = async (stateId, today, districtId) => {
  const formatted = format(today, 'yyyy-MM-dd');

  let url = `api/attendance/state-all-employees-report?stateId=${stateId}&date=${formatted}`
  if (districtId) {
    url += `&districtId=${districtId}`;
  }

  const response = await api.get(url);
  return response.data;

}

// http://localhost:8080/api/attendance/state-all-employees-report?stateId=3&date=2025-11-18